import { render, staticRenderFns } from "./NewQuote.vue?vue&type=template&id=4a85997d"
import script from "./NewQuote.vue?vue&type=script&lang=js"
export * from "./NewQuote.vue?vue&type=script&lang=js"
import style0 from "./NewQuote.vue?vue&type=style&index=0&id=4a85997d&prod&module=true&lang=scss"
import style1 from "./NewQuote.vue?vue&type=style&index=1&id=4a85997d&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports